/** @format */
import { Product } from '@toucan/types/product';

import { centToDecimal } from '@toucan/helpers/currency';

/**
 * Calculates the totals of an array of products
 */

export function calculateTotal(items: Pick<Product, 'value'>[] = []): number {
    return centToDecimal(
        items.reduce((total, { value }) => {
            total += value ?? 0;
            return total;
        }, 0)
    );
}
